<div *ngIf="hasMoreSteps" class="progress-bar animation-fade-in" id="progress-bar">
  <div class="wrapper">
    <div class="icon header-border-reset"></div>
    <div class="icon progress-bar-base"></div>
    <div class="icon progress-bar-filled" id="filled" [style.width]="cssWidthPercentage"></div>
    <div class="icon progress-bar-dot" id="dot" [style.left]="cssLeftPosition"></div>
  </div>
</div>
